import React, { useState, useEffect, useRef } from "react";
import { useAuth } from "navigation/Auth/ProvideAuth";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { updateSubscription, updateUser } from "redux/actions/userActions";
import axios from "axios";
import CommonDivWidget from "components/CommonDivWidget/CommonDivWidget";
import { Steps, Button, message, Row, Col, Spin, BackTop, Modal } from "antd";
import CommonButton from "components/ButtonWidgets/CommonButton/CommonButton";
import "./RegisterPage.css";
import {
  getInitData,
  isBase64,
  isEmpty,
  isEmptyOneField,
  ValidateEmail,
} from "utils/GlobalFunctions";
import { ROOT, ROUTE_WELCOME } from "navigation/CONSTANTS";
import StepInfo from "./StepInfo/StepInfo";
import StepFee from "./StepFee/StepFee";
import UnifiedCheckout from "./UnifiedCheckout/UnifiedCheckout";
import LinkedRegAuth from "./LinkedRegAuth/LinkedRegAuth";

import {
  apiRegisterFailedPayment,
  apiRegisterUser,
  apiRegisterAndPay,
  apiLogRegistrationStep,
} from "services/registerService";
// Note: UnifiedCheckout handles merchant selection (Stax/Forte) internally
import { apiGetRegistrationInfo } from "services/dashboardService";
import { UpdateAppInfo } from "redux/actions/appActions";

const { Step } = Steps;

function RegisterPage(props) {
  const userDataStore = useSelector((x) => x.userDataStore);
  const appDataStore = useSelector((x) => x.appDataStore);
  const location = useLocation();
  const auth = useAuth();
  const dispatch = useDispatch();
  const history = useHistory();
  const [isBusy, setIsBusy] = useState(false);
  const [errorField, setErrorField] = useState([]);
  const [feeValid, setFeeValid] = useState(true);

  const [current, setCurrent] = useState(0);
  const [recordList, setRecordList] = useState([]);
  const [userData, setUserData] = useState({
    camperInfo: [
      {
        sel_reg_id: [],
        sel_trip: "",
        src_fee: 0,
        real_fee: 0,
        sibling_discount: 0,
        zip_discount: 0,
        zip_include: false,
        sibling_include: false,
      },
    ],
    camper_reg_checked: false,
    camper_reg_sel_info: {
      ID: "",
      registration_id: "",
      registration_title: "",
      registration_text: "",
      registration_fee: "",
      registration_sort_order: "",
      sibling_discount: "",
      sibling_discount_amount: "",
      verify_zipcode: "",
      zipcodes_allowed: "",
      checked: false,
    },
    tripList: [],
    isPayment: false,
    discount_amount: 0,
    waiverList: [],
  });
  const [cellPhone, setCellPhone] = useState("___-___-____");
  const [homePhone, setHomePhone] = useState("___-___-____");
  const [aCellPhone, setACellPhone] = useState("___-___-____");
  const [aHomePhone, setAHomePhone] = useState("___-___-____");
  const [contactPhone, setContactPhone] = useState("___-___-____");
  const [acontactPhone, setAContactPhone] = useState("___-___-____");

  const [curDomain, setCurDomain] = useState("");

  const [appInfo, setAppInfo] = useState({
    registration_info: null,
    discount_codes: [],
    group_list: [],
    registration_main_list: [],
    waiver_list: [],
    registrations: [],
  });
  const [isStax, setIsStax] = useState(true);
  const [feeInfo, setFeeInfo] = useState(null);
  const [regType, setRegType] = useState("true");
  const [uiList, setUIList] = useState([]);
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const [isRegClosed, setIsRegClosed] = useState(false);
  const [linkedVerified, setLinkedVerified] = useState(false);
  const [linkedTransactionId, setLinkedTransactionId] = useState(null);

  // Helper to get query param
  function getQueryParam(param) {
    const params = new URLSearchParams(location.search);
    return params.get(param);
  }

  useEffect(() => {
    let tmpDomain = window.location.hostname;
    if (
      tmpDomain.trim() === "localhost" ||
      tmpDomain.trim() === "192.168.100.81"
    ) {
      // tmpDomain = "devtuxedocamp.beclutch.club";
      // tmpDomain = "devyaccamp.beclutch.club";
      tmpDomain = "devwarwick.beclutch.club";
    }

    // If appInfo is missing OR doesn't contain registrations, fetch the legacy registration payload
    const needsFetch = !appDataStore.appInfo || !Array.isArray(appDataStore.appInfo.registrations);
    if (needsFetch) {
      console.log("[RegisterPage] Fetching registration info from backend...");
      setIsBusy(true);
      apiGetRegistrationInfo(tmpDomain)
        .then((res) => {
          setIsBusy(false);
          if (res.result) {
            console.log("[RegisterPage] Registration info loaded:", res.data);
            const regId = getQueryParam("id");
            let fetchedAppInfo = res.data;
            // If a specific registration ID is requested, use its ui_list/group_list/etc.
            if (regId && Array.isArray(fetchedAppInfo.registrations)) {
              const matchedReg = fetchedAppInfo.registrations.find(
                (r) => String(r.ID) === String(regId) || String(r.id) === String(regId)
              );
              if (matchedReg) {
                fetchedAppInfo = {
                  ...fetchedAppInfo,
                  registration_info: matchedReg,
                  ui_list: matchedReg.ui_list || fetchedAppInfo.ui_list,
                  registration_main_list: matchedReg.registration_main_list || fetchedAppInfo.registration_main_list,
                  waiver_list: matchedReg.waiver_list || fetchedAppInfo.waiver_list,
                  group_list: matchedReg.group_list || fetchedAppInfo.group_list,
                  discount_codes: matchedReg.discount_codes || fetchedAppInfo.discount_codes,
                };
              }
            }
            dispatch(UpdateAppInfo({ appInfo: fetchedAppInfo }));
            setAppInfo(fetchedAppInfo);
            setCurDomain(tmpDomain);
            setIsDataLoaded(true);
          } else {
            console.log("Getting registration info error", res);
            message.error("Unable to load registration info");
            history.push(ROOT);
          }
        })
        .catch((err) => {
          console.log("Getting registration info error", err);
          setIsBusy(false);
          message.error("Something went wrong");
          history.push(ROOT);
        });
      return;
    }

    // Use existing appInfo (from store) and select registration
    setCurDomain(tmpDomain);
    let selectedRegistration = null;
    const regId = getQueryParam("id");
    
    // Try to find registration from old-style flat array first
    if (regId && Array.isArray(appDataStore.appInfo.registrations)) {
      const found = appDataStore.appInfo.registrations.find(
        (r) => String(r.ID) === String(regId)
      );
      if (found) {
        selectedRegistration = found;
      }
    }

    // If not found and we have registrations_by_category (new structure), search there
    if (!selectedRegistration && regId && appDataStore.appInfo.registrations_by_category) {
      for (const categoryId in appDataStore.appInfo.registrations_by_category) {
        const regs = appDataStore.appInfo.registrations_by_category[categoryId];
        if (Array.isArray(regs)) {
          const found = regs.find((r) => String(r.id) === String(regId));
          if (found) {
            selectedRegistration = found;
            break;
          }
        }
      }
    }

    // Fallback to registration_info if still not found
    if (!selectedRegistration && appDataStore.appInfo.registration_info) {
      selectedRegistration = appDataStore.appInfo.registration_info;
    }

    // If still no registration, we need to fetch old payload
    if (!selectedRegistration) {
      console.warn("[RegisterPage] No registration found in appInfo; fetching legacy payload");
      setIsBusy(true);
      apiGetRegistrationInfo(tmpDomain)
        .then((res) => {
          setIsBusy(false);
          if (res.result) {
            console.log("[RegisterPage] Registration info loaded:", res.data);
            const regId2 = getQueryParam("id");
            let fetchedAppInfo2 = res.data;
            if (regId2 && Array.isArray(fetchedAppInfo2.registrations)) {
              const matchedReg2 = fetchedAppInfo2.registrations.find(
                (r) => String(r.ID) === String(regId2) || String(r.id) === String(regId2)
              );
              if (matchedReg2) {
                fetchedAppInfo2 = {
                  ...fetchedAppInfo2,
                  registration_info: matchedReg2,
                  ui_list: matchedReg2.ui_list || fetchedAppInfo2.ui_list,
                  registration_main_list: matchedReg2.registration_main_list || fetchedAppInfo2.registration_main_list,
                  waiver_list: matchedReg2.waiver_list || fetchedAppInfo2.waiver_list,
                  group_list: matchedReg2.group_list || fetchedAppInfo2.group_list,
                  discount_codes: matchedReg2.discount_codes || fetchedAppInfo2.discount_codes,
                };
              }
            }
            dispatch(UpdateAppInfo({ appInfo: fetchedAppInfo2 }));
            setAppInfo(fetchedAppInfo2);
            setCurDomain(tmpDomain);
            setIsDataLoaded(true);
          } else {
            message.error("Unable to load registration info");
            history.push(ROOT);
          }
        })
        .catch((err) => {
          setIsBusy(false);
          message.error("Something went wrong loading registration");
          history.push(ROOT);
        });
      return;
    }

    // Build a new appInfo object with the selected registration
    const newAppInfo = {
      ...appDataStore.appInfo,
      registration_info: selectedRegistration,
      ui_list: selectedRegistration.ui_list || appDataStore.appInfo.ui_list,
      registration_main_list: selectedRegistration.registration_main_list || appDataStore.appInfo.registration_main_list,
      waiver_list: selectedRegistration.waiver_list || appDataStore.appInfo.waiver_list,
      group_list: selectedRegistration.group_list || appDataStore.appInfo.group_list,
      discount_codes: selectedRegistration.discount_codes || appDataStore.appInfo.discount_codes,
    };
    setAppInfo(newAppInfo);

    // Fees (guard for undefined)
    if (selectedRegistration && selectedRegistration.credit_fee) {
      setFeeInfo({
        credit_fee: (
          parseFloat(selectedRegistration.credit_fee) / 100
        ).toFixed(3),
        debit_fee: (parseFloat(selectedRegistration.debit_fee) / 100).toFixed(3),
        echeck_fee: parseFloat(selectedRegistration.echeck_fee),
      });
    }

    // Merchant (now safe because selectedRegistration is guaranteed to exist)
    const staxInfo = selectedRegistration.merchant || "stax";
    setIsStax(staxInfo === "stax");

    setUIList(newAppInfo.ui_list || []);
    setIsDataLoaded(true);

    // After loading registration info, check if registration is closed
    if (
      appInfo &&
      appInfo.registration_info &&
      appInfo.registration_info.status !== "1"
    ) {
      console.log("isRegClosed", appInfo.registration_info.status);
      setIsRegClosed(true);
    } else {
      setIsRegClosed(false);
    }

    initGlobalVal();
  }, [location.search, appDataStore.appInfo]);

  // Only run initGlobalVal after data is loaded
  useEffect(() => {
    if (isDataLoaded) {
      initGlobalVal();
    }
    // eslint-disable-next-line
  }, [isDataLoaded]);

  const initGlobalVal = () => {
    if (!appDataStore.appInfo) return;
    const step = localStorage.getItem("camper_step");
    if (step != null) {
      setCurrent(parseInt(step));
    }

    let tmpList = appDataStore.appInfo.group_list
      ? [...appDataStore.appInfo.group_list]
      : [];
    let tmpSrcList = tmpList.map((x, index) => {
      return {
        id: x.ID,
        title: x.registration_group_short_name,
        description: x.registration_group_name,
        price: x.registration_group_fee,
        checked: false,
        discount_available: x.discount_available,
        open: x.open_close,
        max_registrations: x.max_registrations,
        current_registrations: x.current_registrations,
      };
    });

    let tmpRegList = appDataStore.appInfo.registration_main_list
      ? [...appDataStore.appInfo.registration_main_list]
      : [];
    tmpRegList = tmpRegList.map((x) => {
      let tmpZipStr = x.zipcodes_allowed;
      let tmpZipList = [];
      if (tmpZipStr != null && tmpZipStr.trim().length != 0) {
        tmpZipList = tmpZipStr.split(",");
        tmpZipList = tmpZipList.map((y) => {
          return y.trim();
        });
      }
      return {
        ...x,
        checked: false,
        zip_code_list: tmpZipList,
      };
    });

    let tmpWaiverList = appDataStore.appInfo.waiver_list
      ? [...appDataStore.appInfo.waiver_list]
      : [];
    tmpWaiverList = tmpWaiverList.map((x) => {
      return {
        ...x,
        checked: false,
        first_name: "",
        last_name: "",
        allow_no_checked: false,
      };
    });

    let authUserInfo = {
      p_first_name: "",
      p_last_name: "",
      p_email: "",
      p_cell_phone: "",
    };
    if (
      appDataStore.appInfo?.ui_list.filter(
        (x) => x.reg_column_name == "p_first_name"
      ).length > 0 &&
      userDataStore?.first_name != ""
    ) {
      authUserInfo.p_first_name = userDataStore.first_name;
    }
    if (
      appDataStore.appInfo?.ui_list.filter(
        (x) => x.reg_column_name == "p_last_name"
      ).length > 0 &&
      userDataStore?.last_name != ""
    ) {
      authUserInfo.p_last_name = userDataStore.last_name;
    }
    if (
      appDataStore.appInfo?.ui_list.filter(
        (x) => x.reg_column_name == "p_email"
      ).length > 0 &&
      userDataStore?.email != ""
    ) {
      authUserInfo.p_email = userDataStore.email;
    }
    if (
      appDataStore.appInfo?.ui_list.filter(
        (x) => x.reg_column_name == "p_cell_phone"
      ).length > 0 &&
      userDataStore?.cell_phone != ""
    ) {
      authUserInfo.p_cell_phone = userDataStore.cell_phone;
    }
    let tmpCamps = [];
    let tmpRecords = [...recordList];
    if (userDataStore?.camp_users && userDataStore?.camp_users.length > 0) {
      userDataStore?.camp_users
        .filter((t) => t.checked)
        .map((x) => {
          if (x?.camper_record) {
            tmpRecords = [
              ...tmpRecords,
              {
                name: x?.camper_record
                  ? x?.camper_record.split("uploads/camper/").length > 1
                    ? x?.camper_record.split("uploads/camper/")[1]
                    : ""
                  : "",
              },
            ];
          }
          let tmpObj = {
            sel_reg_id: [],
            sel_trip: "",
            src_fee: 0,
            real_fee: 0,
            sibling_discount: 0,
            zip_discount: 0,
            zip_include: false,
            sibling_include: false,
          };
          let tmpHealthEncrypt = isBase64(x?.camper_health);

          tmpObj = {
            ...tmpObj,
            ...x,
            camper_record_path: x?.camper_record,
            camper_health: tmpHealthEncrypt
              ? window.atob(x?.camper_health)
              : x?.camper_health,
          };
          tmpCamps = [...tmpCamps, tmpObj];
        });
    }
    if (tmpCamps.length == 0) {
      tmpCamps = [
        ...tmpCamps,
        {
          sel_reg_id: [],
          sel_trip: "",
          src_fee: 0,
          real_fee: 0,
          sibling_discount: 0,
          zip_discount: 0,
          zip_include: false,
          sibling_include: false,
        },
      ];
    }
    setRecordList(tmpRecords);
    setUserData({
      ...userData,
      ...authUserInfo,
      camperInfo: tmpCamps,
      tripList: [...tmpSrcList],
      regList: [...tmpRegList],
      waiverList: [...tmpWaiverList],
      disCountInfo: [...appDataStore.appInfo.discount_codes],
      ...(tmpCamps.length == 0 ? {} : { ...tmpCamps[tmpCamps.length - 1] }),
    });
  };
  const isLinkedReg = appInfo?.registration_info?.registration_type === "linked";

  const onLinkedVerified = ({ participants, email, parentTransactionId, groupList }) => {
    setLinkedTransactionId(parentTransactionId);
    // Build camperInfo entries from verified participants
    const camperInfoList = participants.map((p) => ({
      sel_reg_id: [],
      sel_trip: "",
      src_fee: 0,
      real_fee: 0,
      sibling_discount: 0,
      zip_discount: 0,
      zip_include: false,
      sibling_include: false,
      parent_participant_id: p.id,   // original participant_id — tells backend to skip creating a new participant row
      camper_first_name: p.camper_first_name,
      camper_last_name: p.camper_last_name,
      camper_age: p.camper_age,
      camper_birthday: p.camper_birthday,
      camper_gender: p.camper_gender,
      camper_grade: p.camper_grade,
      camper_email: p.camper_email,
      camper_street: p.camper_street,
      camper_city: p.camper_city,
      camper_state: p.camper_state,
      camper_zip: p.camper_zip,
      camper_t_shirt: p.camper_t_shirt,
      camper_health: p.camper_health,
      p_first_name: p.p_first_name,
      p_last_name: p.p_last_name,
      p_email: p.p_email,
      p_cell_phone: p.p_cell_phone,
      p_home_phone: p.p_home_phone,
      p_relation: p.p_relation,
    }));
    // Map the parent registration's group_list into tripList format
    const tripList = (groupList || []).map((x) => ({
      id: x.ID,
      title: x.registration_group_short_name,
      description: x.registration_group_name,
      price: x.registration_group_fee,
      checked: false,
      discount_available: x.discount_available,
      open: x.open_close,
      max_registrations: x.max_registrations,
      current_registrations: x.current_registrations,
    }));
    setUserData((prev) => ({
      ...prev,
      camperInfo: camperInfoList,
      tripList,
      p_first_name: participants[0]?.p_first_name || "",
      p_last_name: participants[0]?.p_last_name || "",
      p_email: email,
      p_cell_phone: participants[0]?.p_cell_phone || "",
      p_home_phone: participants[0]?.p_home_phone || "",
    }));
    setLinkedVerified(true);
    setCurrent(1); // skip straight to StepFee
  };

  const next = () => {
    if (current == 0) {
      if (!validateOneFields()) return;

      // Log Step 1 data
      const step1Data = {
        ...userData,
        registration_id: appInfo.registration_info?.ID,
        registration_name: appInfo.registration_info?.registration_name,
        reg_type: regType,
      };
      setIsBusy(true);

      apiLogRegistrationStep(1, step1Data)
        .then((res) => {
          console.log("logStep1Data", res);
          setIsBusy(false);

          if (res.result) {
            saveLocalData(current + 1);
            setCurrent(current + 1);
            window.scrollTo(0, 0);
          } else {
            message.error(res.message);
          }
        })
        .catch((err) => {
          setIsBusy(false);

          console.error("Failed to log Step 1 data:", err);
          message.error("Failed to save registration data");
        });
    } else if (current == 1) {
      if (!validateTwoFields()) return;
      if (!validateOneFields()) {
        message.error(
          "Some participant information is missing. Please go back and complete Step 1."
        );
        return;
      }

      // Log Step 2 data
      const step2Data = {
        ...userData,
        registration_id: appInfo.registration_info?.ID,
        registration_name: appInfo.registration_info?.registration_name,
        reg_type: regType,
      };
      setIsBusy(true);

      apiLogRegistrationStep(2, step2Data)
        .then((res) => {
          setIsBusy(false);
          console.log("logStep2Data", res);
          if (res.result) {
            calcFee();
            setCurrent(current + 1);
            window.scrollTo(0, 0);
          } else {
            message.error(res.message);
          }
        })
        .catch((err) => {
          setIsBusy(false);

          console.error("Failed to log Step 2 data:", err);
          message.error("Failed to save registration data");
        });
    } else if (current == 2) {
      if (!validateThreeFields()) return;
      if (!validateOneFields() || !validateTwoFields()) {
        message.error(
          "Some registration information is missing. Please go back and complete all steps."
        );
        return;
      }

      // Log Step 3 data before payment
      const step3Data = {
        ...userData,
        registration_id: appInfo.registration_info?.ID,
        registration_name: appInfo.registration_info?.registration_name,
        reg_type: regType,
      };
      setIsBusy(true);

      apiLogRegistrationStep(3, step3Data)
        .then((res) => {
          setIsBusy(false);
          console.log("logStep3Data", res);
          if (res.result) {
            onPurchase();
          } else {
            message.error(res.message);
          }
        })
        .catch((err) => {
          setIsBusy(false);

          console.error("Failed to log Step 3 data:", err);
          message.error("Failed to save registration data");
        });
    }
  };
  const calcFee = () => {
    let src_total_amount = 0;
    let total_amount = 0;
    let total_credit = 0;
    let total_debit = 0;
    let total_echeck = 0;

    const regInfo = appDataStore?.appInfo?.registration_info || {};
    const toDateOnly = (dateValue) => {
      if (!dateValue) return null;
      const d = new Date(dateValue);
      if (Number.isNaN(d.getTime())) return null;
      d.setHours(0, 0, 0, 0);
      return d;
    };
    const toAmount = (value) => {
      const n = parseFloat(value);
      return Number.isNaN(n) ? 0 : n;
    };

    userData.camperInfo
      .filter((x) => x.sel_reg_id.length != 0)
      .map((camper, key) => {
        camper.sel_reg_id.map((reg) => {
          src_total_amount += parseFloat(reg.real_fee);
        });
      });

    const hasSelectedRegistration = userData.camperInfo.some(
      (camper) => Array.isArray(camper.sel_reg_id) && camper.sel_reg_id.length > 0
    );

    userData.camperInfo.map((camper, key) => {
      userData.tripList.map((x, index) => {
        if (userData.camperInfo[key].sel_trip.includes(x.id + ",")) {
          src_total_amount += parseFloat(x.price);
        }
      });
    });

    const now = new Date();
    now.setHours(0, 0, 0, 0);

    const earlyRegDiscountAmount = toAmount(regInfo.early_reg_discount_amount);
    const earlyRegDiscountDate = toDateOnly(regInfo.early_reg_discount_date);
    const lateRegFeeAmount = toAmount(regInfo.late_reg_fee_amount);
    const lateRegFeeDate = toDateOnly(regInfo.late_reg_fee_date);

    const appliedEarlyRegDiscount =
      hasSelectedRegistration &&
      earlyRegDiscountAmount > 0 &&
      earlyRegDiscountDate &&
      now <= earlyRegDiscountDate
        ? earlyRegDiscountAmount
        : 0;

    const appliedLateRegFee =
      hasSelectedRegistration &&
      lateRegFeeAmount > 0 &&
      lateRegFeeDate &&
      now >= lateRegFeeDate
        ? lateRegFeeAmount
        : 0;

    total_amount = src_total_amount - appliedEarlyRegDiscount + appliedLateRegFee;
    if (total_amount < 0) {
      total_amount = 0;
    }

    // Calculate processing fee based on the DISCOUNTED subtotal (total_amount)
    // If subtotal is $898 with $25 discount, fee = ($873 × 3%) = $26.19
    let processing_credit_fee = 0;
    let processing_debit_fee = 0;
    let processing_echeck_fee = 0;
    if (feeInfo) {
      processing_credit_fee = parseFloat(
        (total_amount * appDataStore.appInfo.registration_info.credit_fee) / 100
      ).toFixed(3);
      processing_debit_fee = parseFloat(
        (total_amount * appDataStore.appInfo.registration_info.debit_fee) / 100
      ).toFixed(3);
      processing_echeck_fee = feeInfo.echeck_fee;
    }

    if (!isStax) {
      // Only apply minimums when the discounted subtotal is non-zero.
      // If a discount brings total_amount to $0, no processing fee should apply.
      if (parseFloat(total_amount) != 0) {
        if (
          processing_credit_fee <
          appDataStore.appInfo.registration_info.credit_min
        ) {
          processing_credit_fee =
            appDataStore.appInfo.registration_info.credit_min;
        }
        if (
          processing_debit_fee <
          appDataStore.appInfo.registration_info.debit_min
        ) {
          processing_debit_fee =
            appDataStore.appInfo.registration_info.debit_min;
        }
        if (processing_echeck_fee < 2.0) {
          processing_echeck_fee = 2.0;
        }
      }
    }

    total_credit = parseFloat(
      parseFloat(total_amount) + parseFloat(processing_credit_fee)
    ).toFixed(3);
    total_debit = parseFloat(
      parseFloat(total_amount) + parseFloat(processing_debit_fee)
    ).toFixed(3);
    total_echeck = parseFloat(
      parseFloat(total_amount) + parseFloat(processing_echeck_fee)
    ).toFixed(3);

    let tmpObj = { ...userData };
    tmpObj = {
      ...tmpObj,
      total_amount: parseFloat(total_amount).toFixed(3),
      src_total_amount: parseFloat(src_total_amount).toFixed(3),
      early_reg_discount_amount_applied: parseFloat(appliedEarlyRegDiscount).toFixed(2),
      late_reg_fee_amount_applied: parseFloat(appliedLateRegFee).toFixed(2),

      processing_credit_fee: processing_credit_fee,
      processing_debit_fee: processing_debit_fee,
      processing_echeck_fee: processing_echeck_fee,

      total_credit: parseFloat(total_credit).toFixed(3),
      total_debit: parseFloat(total_debit).toFixed(3),
      total_echeck: parseFloat(total_echeck).toFixed(3),

      total_checkout: parseFloat(total_credit).toFixed(2),
      processing_fee: parseFloat(processing_credit_fee).toFixed(2),
    };
    setUserData(tmpObj);
    localStorage.setItem("camper_user_info", JSON.stringify(tmpObj));
    localStorage.setItem("camper_step", 2);
  };
  const saveLocalData = (cur) => {
    localStorage.setItem("camper_user_info", JSON.stringify(userData));
    localStorage.setItem("camper_step", cur);
  };
  const prev = () => {
    if (current == 0) {
      history.goBack();
    } else {
      setCurrent(current - 1);
    }
  };

  const onPurchase = (
    payment_method = "",
    transaction_id = "",
    entered_by = "",
    authorization_code = "",
    location_id = ""
  ) => {
    const isManualPayment = payment_method === "manual";
    const manualTotalCheckout = parseFloat(
      (parseFloat(userData?.total_amount || 0) - parseFloat(userData?.discount_amount || 0)).toFixed(2)
    );
    const effectiveProcessingFee = isManualPayment ? 0 : parseFloat(userData?.processing_fee || 0);
    const effectiveTotalCheckout = isManualPayment ? manualTotalCheckout : parseFloat(userData?.total_checkout || 0);

    let param = { ...userData };
    param = {
      ...param,
      payment_method,
      transaction_id,
      entered_by,
      authorization_code,
      location_id,
      recordList,
      reg_type: regType,
      registration_id: appInfo.registration_info?.ID,
      registration_name: appInfo.registration_info?.registration_name,
      yaccamp: curDomain.includes("yaccamp") ? "1" : "0",
      linked_transaction_id: linkedTransactionId || "",
      isStax,
      userData: userData,
      processing_fee: effectiveProcessingFee,
      total_checkout: effectiveTotalCheckout,
    };
    setIsBusy(true);
    apiRegisterUser(param)
      .then((res) => {
        setIsBusy(false);
        if (res.result) {
          try {
            localStorage.setItem(
              "welcome_context",
              JSON.stringify({
                registration_name: appInfo?.registration_info?.registration_name || "",
                registration_type: appInfo?.registration_info?.registration_type || "",
                total_checkout: effectiveTotalCheckout,
                payment_method,
                pay_status: payment_method === "manual" ? 0 : 1,
              })
            );
          } catch {}

          message.success(
            "Welcome " + appInfo?.registration_info?.registration_name + "!"
          );
          localStorage.removeItem("camper_user_info");
          localStorage.removeItem("camper_step");
          localStorage.removeItem("camper_registration_type");
          setTimeout(() => {
            history.replace(ROUTE_WELCOME);
          }, 300);
        } else {
          message.error((res.message || res.msg || "Registration failed.") + " Please try again by clicking the Register button on the home page.");
          history.push(ROOT);
          console.log('Register User Failed:', res)
        }
      })
      .catch((err) => {
        setIsBusy(false);
        message.error(err?.message || "Registration failed. Please try again.");
      });
  };

  const FORTE_SYSTEM_ERROR_MSG = "Registration Error. Payment UNSUCCESSFUL. Please contact the administrator or email support@beclutch.club";

  const onForteRegisterAndPay = async (token, { cardType, service_fee_amount }) => {
    const param = {
      ...userData,
      one_time_token: token,
      payment_method: cardType,
      card_type: cardType,
      authorization_amount: parseFloat(userData.total_amount),
      service_fee_amount,
      billing_address: {
        first_name: userData.bill_first_name,
        last_name: userData.bill_last_name,
        address: userData.bill_address,
        city: userData.bill_city,
        state: userData.bill_state,
        postal_code: userData.bill_postal_code,
      },
      domain: curDomain,
      recordList,
      reg_type: regType,
      registration_id: appInfo.registration_info?.ID,
      registration_name: appInfo.registration_info?.registration_name,
      yaccamp: curDomain.includes("yaccamp") ? "1" : "0",
      linked_transaction_id: linkedTransactionId || "",
      userData,
    };

    setIsBusy(true);
    try {
      const res = await apiRegisterAndPay(param);
      setIsBusy(false);
      if (res.result) {
        try {
          localStorage.setItem("welcome_context", JSON.stringify({
            registration_name: appInfo?.registration_info?.registration_name || "",
            registration_type: appInfo?.registration_info?.registration_type || "",
            total_checkout: parseFloat(userData.total_checkout),
            payment_method: cardType,
            pay_status: 1,
          }));
        } catch {}
        message.success("Welcome " + appInfo?.registration_info?.registration_name + "!");
        localStorage.removeItem("camper_user_info");
        localStorage.removeItem("camper_step");
        localStorage.removeItem("camper_registration_type");
        setTimeout(() => { history.replace(ROUTE_WELCOME); }, 300);
      } else if (res.error_type === "payment") {
        message.error(res.msg || res.message || "Your payment was declined. Please try a different payment method.");
        // Stay on the checkout page so the user can retry with a different card
      } else {
        message.error(FORTE_SYSTEM_ERROR_MSG);
        history.push(ROOT);
      }
    } catch (err) {
      setIsBusy(false);
      message.error(FORTE_SYSTEM_ERROR_MSG);
      history.push(ROOT);
    }
  };

  const onPaymentFail = (payment_method = "", err_res, api_name) => {
    setIsBusy(true);
    let param = { ...userData };
    param = {
      ...param,
      payment_method,
      err_res,
      api_name,
    };
    setIsBusy(true);
    apiRegisterFailedPayment(param)
      .then((res) => {
        setIsBusy(false);
        if (res.result) {
        } else {
          message.error(res.msg);
        }
      })
      .catch((err) => {
        setIsBusy(false);
        message.error("Something went wrong");
      });
  };

  const steps = [
    {
      title: "Participant Info",
      subtitle: "Please enter participant info below.",
      content: "",
    },
    {
      title: "Participant Fees",
      subtitle: "Please select the fee(s) that apply to each participant.",
      content: "",
    },
    {
      title: "Checkout",
      subtitle:
        "Please reivew your registration fees and select a payment method.",
      content: "",
    },
  ];

  const validateOneFields = () => {
    console.log("validateOneFields");
    var errorList = Array();

    let tmpList = [...userData.camperInfo];

    let tmpUIlist = [...uiList];
    let participantUiList = tmpUIlist.filter((x) => x.group_type == "1");
    tmpList.map((x, index) => {
      participantUiList.map((uiItem, uIndex) => {
        if (uiItem.is_required == "true" && uiItem.ui_type != "5") {
          errorList = isEmpty(x, uiItem.reg_column_name, errorList, index);
        }
      });
    });
    let otherUIList = tmpUIlist.filter((x) => x.group_type != "1");
    otherUIList.map((uiItem, uIndex) => {
      if (uiItem.is_required == "true") {
        errorList = isEmpty(userData, uiItem.reg_column_name, errorList);
      }
    });
    let includeFile =
      participantUiList.filter(
        (x) =>
          x.ui_type == "5" &&
          x.is_required == "true" &&
          x.is_filepicker == "true"
      ).length > 0
        ? true
        : false;
    if (includeFile) {
      let tmpRecordList = [...recordList];
      if (tmpList.length != tmpRecordList.length) {
        errorList.push(tmpRecordList.length + "record");
      }
      tmpRecordList.map((x, index) => {
        errorList = isEmptyOneField(x, "record", errorList, index);
      });
    }

    setErrorField([...errorList]);

    return errorList.length == 0;
  };
  const validateTwoFields = () => {
    console.log("validateTwoFields");
    let valid = true;
    let errorList = Array();

    // For linked registrations, only extra programs (sel_trip) are required
    if (isLinkedReg) {
      valid = userData.camperInfo.some((c) => c.sel_trip && c.sel_trip.replace(/,/g, "").trim().length > 0);
      if (!valid) {
        message.error("Please select at least one extra program to proceed");
        return false;
      }
      return true;
    }

    for (let i = 0; i < userData.camperInfo.length; i++) {
      if (userData.camperInfo[i].sel_reg_id.length != 0) {
        valid = true;
        break;
      } else {
        valid = false;
      }
    }
    if (!valid) {
      for (let i = 0; i < userData.camperInfo.length; i++) {
        if (userData.camperInfo[i].sel_trip) {
          valid = true;
          break;
        } else {
          valid = false;
        }
      }
    }

    if (!valid) {
      message.error(
        "Please select a registration or an extra program to proceed"
      );
      return false;
    }
    if (regType == "true") {
      let tmpList = [...userData.waiverList];
      for (let index = 0; index < tmpList.length; index++) {
        let tmpWaiver = tmpList[index];
        if (tmpWaiver.allow_no == "1") {
          if (!tmpWaiver.allow_no_checked) {
            errorList = isEmpty(tmpWaiver, "first_name", errorList, index);
            errorList = isEmpty(tmpWaiver, "last_name", errorList, index);
            if (!tmpWaiver.checked) {
              valid = false;
              break;
            }
          }
        } else {
          errorList = isEmpty(tmpWaiver, "first_name", errorList, index);
          errorList = isEmpty(tmpWaiver, "last_name", errorList, index);
          if (!tmpWaiver.checked) {
            valid = false;
            break;
          }
        }
      }
    }
    setErrorField(errorList);
    if (!valid && regType == "true") {
      message.error(
        "You must confirm all electronic signature fields before proceeding"
      );
    }
    return valid && errorField.length == 0;
  };
  const validateThreeFields = () => {
    console.log("validateThreeFields");
    if (!userData.isPayment) {
      message.error("Payment Not Completed");
    }
    return userData.isPayment;
  };
  const onBack = () => {
    if (current == 0) {
      history.push(ROOT);
    } else {
      setCurrent(current - 1);
    }
  };

  // Dedicated useEffect to update isRegClosed when appInfo changes
  useEffect(() => {
    if (
      appInfo &&
      appInfo.registration_info &&
      appInfo.registration_info.status !== "1"
    ) {
      setIsRegClosed(true);
    } else {
      setIsRegClosed(false);
    }
  }, [appInfo]);

  // Log isRegClosed whenever it changes
  useEffect(() => {
    console.log("isRegClosed", isRegClosed);
  }, [isRegClosed]);

  return (
    <div className="register-page">
      <Spin spinning={isBusy}>
        <CommonDivWidget>
          {/* Registration Closed Modal */}
          <Modal
            visible={isRegClosed}
            title="Registration Closed"
            footer={null}
            closable={false}
            centered
          >
            <p>
              Registration is currently closed. Please check back later or
              contact the administrator for more information.
            </p>
            <Button type="primary" onClick={() => history.push(ROOT)}>
              Go to Home
            </Button>
          </Modal>
          {/* Only show registration steps if not closed */}
          {!isRegClosed && (
            <>
              <div style={{ position: "absolute" }}>
                <img
                  src="/assets/images/ic_back.png"
                  style={{ width: 22, margin: "5px 0px", cursor: "pointer" }}
                  onClick={() => {
                    onBack();
                  }}
                />
              </div>
              <div className="title">
                {appInfo.registration_info?.registration_name}
              </div>
              <div className="title">{steps[current].title}</div>
              <div className="sub-title">{steps[current].subtitle}</div>
              <Steps current={current} className="step">
                {steps.map((item) => (
                  <Step key={item.title} />
                ))}
              </Steps>
              <div className="steps-content">
                {current == 0 && (
                  isLinkedReg ? (
                    <LinkedRegAuth
                      registrationId={appInfo.registration_info?.ID}
                      onVerified={onLinkedVerified}
                    />
                  ) : (
                    <StepInfo
                      userData={userData}
                      setUserData={setUserData}
                      errorField={errorField}
                      setErrorField={setErrorField}
                      homePhone={homePhone}
                      setHomePhone={setHomePhone}
                      cellPhone={cellPhone}
                      setCellPhone={setCellPhone}
                      contactPhone={contactPhone}
                      setContactPhone={setContactPhone}
                      acontactPhone={acontactPhone}
                      setAContactPhone={setAContactPhone}
                      aCellPhone={aCellPhone}
                      setACellPhone={setACellPhone}
                      aHomePhone={aHomePhone}
                      setAHomePhone={setAHomePhone}
                      onNext={next}
                      recordList={recordList}
                      setRecordList={setRecordList}
                      regType={regType}
                      curDomain={curDomain}
                      uiList={uiList}
                    />
                  )
                )}
                {current == 1 && (
                  <StepFee
                    userData={userData}
                    setUserData={setUserData}
                    errorField={errorField}
                    setErrorField={setErrorField}
                    onNext={next}
                    regType={regType}
                    curDomain={curDomain}
                    uiList={uiList}
                    appInfo={appInfo}
                    isLinkedReg={isLinkedReg}
                  />
                )}
                {current == 2 && (
                  <UnifiedCheckout
                    appInfo={appInfo}
                    userData={userData}
                    setUserData={setUserData}
                    errorField={errorField}
                    setErrorField={setErrorField}
                    onNext={next}
                    onRegister={onPurchase}
                    onRegisterAndPay={onForteRegisterAndPay}
                    onPaymentFail={onPaymentFail}
                    recordList={recordList}
                    regType={regType}
                    curDomain={curDomain}
                    feeInfo={feeInfo}
                  />
                )}
              </div>
              <div className="steps-action">
                {errorField.length != 0 && (
                  <div className="valid-rect">
                    <span>Correct errors in red above before proceeding</span>
                  </div>
                )}
                {!feeValid && (
                  <div className="valid-rect">
                    <span>Please select trip</span>
                  </div>
                )}
                {current == 0 && !isLinkedReg && (
                  <div>
                    <Row justify="center">
                      <CommonButton
                        customClass="register-next-button"
                        onClick={() => next()}
                      >
                        Next
                      </CommonButton>
                    </Row>
                    <Row justify="center" style={{ marginTop: 10 }}>
                      <CommonButton
                        customClass="register-cancel-button"
                        onClick={() => prev()}
                      >
                        Cancel
                      </CommonButton>
                    </Row>
                  </div>
                )}
                {current == 1 && (
                  <Row>
                    <Col flex="180" style={{ marginTop: 25 }}>
                      <CommonButton
                        customClass="register-prev-button"
                        onClick={() => prev()}
                      >
                        Previous
                      </CommonButton>
                    </Col>
                    <Col flex="auto" style={{ marginTop: 25 }}>
                      <CommonButton
                        customClass="register-next-button"
                        onClick={() => next()}
                      >
                        Next
                      </CommonButton>
                    </Col>
                  </Row>
                )}
                {current == 2 && (
                  <Row justify="center">
                    <Col style={{ marginTop: 25 }}>
                      <CommonButton
                        customClass="register-prev-button"
                        onClick={() => prev()}
                      >
                        Previous
                      </CommonButton>
                    </Col>
                  </Row>
                )}
              </div>
              <BackTop />
            </>
          )}
        </CommonDivWidget>
      </Spin>
    </div>
  );
}

export default RegisterPage;
